// Canonical Malaysian state names — must match the server's
// server/src/common/constants/address-states.ts (also the keys of the
// EasyParcel ISO 3166-2 subdivision map).
export const ADDRESS_STATE_NAMES: string[] = [
  'Johor',
  'Kedah',
  'Kelantan',
  'Melaka',
  'Negeri Sembilan',
  'Pahang',
  'Pulau Pinang',
  'Perak',
  'Perlis',
  'Sabah',
  'Sarawak',
  'Selangor',
  'Terengganu',
  'WP Kuala Lumpur',
  'WP Labuan',
  'WP Putrajaya',
]
